/* =========================================================
   Plain Jane 2.0 - gallery navigation
   - left / right arrows on the featured photo (desktop + mobile)
   - swipe on the featured photo (mobile)
   - left / right arrows that scroll the small gallery row
   It does NOT replace the theme's own image swapping: it simply
   triggers a click on the matching thumbnail, so product-item-zoom.js
   (main image swap + magnifier) keeps working exactly as before.
   ========================================================= */
(function () {
  'use strict';

  var BREAKPOINT = 805;

  var state = {
    ids: [],
    index: 0,
    loop: true,
    swipe: true,
    ready: false
  };

  function qa(selector, ctx) {
    return Array.prototype.slice.call((ctx || document).querySelectorAll(selector));
  }

  function setClass(el, name, on) {
    if (!el) return;
    if (on) el.classList.add(name);
    else el.classList.remove(name);
  }

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches ? el.matches(selector) : el.msMatchesSelector(selector)) return el;
      el = el.parentElement;
    }
    return null;
  }

  /* ---------------------------------------------------------- data */
  function readData() {
    var el = document.getElementById('pj-gallery-data');
    if (!el) return false;

    var data;
    try {
      data = JSON.parse(el.textContent || el.innerHTML);
    } catch (e) {
      return false;
    }

    state.ids = (data.media || []).map(String);
    state.loop = data.loop !== false;
    state.swipe = data.swipe !== false;

    var start = state.ids.indexOf(String(data.featured));
    state.index = start < 0 ? 0 : start;

    return state.ids.length > 0;
  }

  /* ---------------------------------------------------------- helpers */
  function thumbsFor(id) {
    return qa('.product-img-grid-item[data-media-id="' + id + '"]');
  }

  function markActive(id) {
    qa('.product-img-grid-item').forEach(function (thumb) {
      var on = thumb.getAttribute('data-media-id') === id;
      if (on) thumb.classList.add('pj-thumb-active');
      else thumb.classList.remove('pj-thumb-active');
    });
  }

  function revealThumb(id) {
    qa('.pj-thumbs-carousel').forEach(function (strip) {
      if (strip.scrollWidth <= strip.clientWidth + 2) return;
      var thumb = strip.querySelector('.product-img-grid-item[data-media-id="' + id + '"]');
      if (!thumb) return;
      var left = thumb.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2;
      if (left < 0) left = 0;
      if (strip.scrollTo) strip.scrollTo({ left: left, behavior: 'smooth' });
      else strip.scrollLeft = left;
    });
  }

  /* ---------------------------------------------------------- navigation */
  function setIndex(i, silent) {
    var id = state.ids[i];
    if (!id) return;
    state.index = i;
    markActive(id);
    if (!silent) revealThumb(id);
    updateMainArrows();
  }

  function go(direction) {
    var total = state.ids.length;
    if (total < 2) return;

    var next = state.index + direction;
    if (next < 0) {
      if (!state.loop) return;
      next = total - 1;
    }
    if (next > total - 1) {
      if (!state.loop) return;
      next = 0;
    }

    var id = state.ids[next];
    var list = thumbsFor(id);
    var target = null;
    for (var i = 0; i < list.length; i++) {
      if (list[i].offsetParent !== null) { target = list[i]; break; }
    }
    if (!target) target = list[0];
    if (!target) return;

    setIndex(next);
    target.click(); /* theme's own handler swaps the main photo */
  }

  function updateMainArrows() {
    if (state.loop) return;
    var prev = document.querySelector('.pj-arrow--main.pj-arrow--prev');
    var next = document.querySelector('.pj-arrow--main.pj-arrow--next');
    setClass(prev, 'pj-arrow--off', state.index <= 0);
    setClass(next, 'pj-arrow--off', state.index >= state.ids.length - 1);
  }

  /* ---------------------------------------------------------- thumb row */
  function scrollStrip(button, direction) {
    var wrap = closest(button, '.pj-thumbs-wrap');
    var strip = wrap && wrap.querySelector('.pj-thumbs-carousel');
    if (!strip) return;

    var first = strip.querySelector('.product-img-grid-item');
    var step = first ? (first.offsetWidth + 8) * 3 : strip.clientWidth * 0.8;
    step = Math.max(Math.min(step, strip.clientWidth * 0.9), 60);

    if (strip.scrollBy) strip.scrollBy({ left: direction * step, behavior: 'smooth' });
    else strip.scrollLeft += direction * step;
  }

  function refreshThumbArrows() {
    qa('.pj-thumbs-wrap').forEach(function (wrap) {
      var strip = wrap.querySelector('.pj-thumbs-carousel');
      var arrows = qa('.pj-arrow--thumb', wrap);
      if (!strip) {
        arrows.forEach(function (a) { a.hidden = true; });
        return;
      }

      var scrollable = strip.scrollWidth - strip.clientWidth > 2;
      setClass(strip, 'pj-thumbs-center', !scrollable);
      arrows.forEach(function (a) { a.hidden = !scrollable; });
      if (!scrollable) return;

      var atStart = strip.scrollLeft <= 1;
      var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 1;
      arrows.forEach(function (a) {
        var isPrev = a.classList.contains('pj-arrow--prev');
        setClass(a, 'pj-arrow--off', isPrev ? atStart : atEnd);
      });
    });
  }

  /* ---------------------------------------------------------- swipe */
  function bindSwipe() {
    var wrap = document.querySelector('.pj-main-media-wrap');
    if (!wrap || wrap.getAttribute('data-pj-swipe') === 'on') return;
    wrap.setAttribute('data-pj-swipe', 'on');

    var x0 = null;
    var y0 = null;
    var t0 = 0;

    wrap.addEventListener('touchstart', function (e) {
      if (!state.swipe || window.innerWidth > BREAKPOINT) return;
      var t = e.changedTouches[0];
      x0 = t.clientX;
      y0 = t.clientY;
      t0 = Date.now();
    }, { passive: true });

    wrap.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var t = e.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      x0 = null;
      if (Date.now() - t0 > 900) return;
      if (Math.abs(dx) < 45) return;
      if (Math.abs(dx) < Math.abs(dy) * 1.3) return;
      go(dx < 0 ? 1 : -1);
    }, { passive: true });
  }

  /* ---------------------------------------------------------- events */
  function bindGlobal() {
    if (window.__pjGalleryBound) return;
    window.__pjGalleryBound = true;

    document.addEventListener('click', function (e) {
      var arrow = closest(e.target, '[data-pj-nav]');
      if (arrow) {
        e.preventDefault();
        var action = arrow.getAttribute('data-pj-nav');
        if (action === 'main-prev') go(-1);
        else if (action === 'main-next') go(1);
        else if (action === 'thumb-prev') scrollStrip(arrow, -1);
        else if (action === 'thumb-next') scrollStrip(arrow, 1);
        return;
      }

      /* keep our index in sync when a thumbnail is clicked directly */
      var thumb = closest(e.target, '.product-img-grid-item');
      if (thumb) {
        var id = thumb.getAttribute('data-media-id');
        var i = state.ids.indexOf(String(id));
        if (i > -1) setIndex(i, true);
      }
    });

    document.addEventListener('scroll', function (e) {
      if (e.target && e.target.classList && e.target.classList.contains('pj-thumbs-carousel')) {
        refreshThumbArrows();
      }
    }, true);

    /* thumbnails only get their real width once the images are decoded */
    document.addEventListener('load', function (e) {
      var el = e.target;
      if (el && el.tagName === 'IMG' && closest(el, '.pj-thumbs-carousel')) {
        refreshThumbArrows();
      }
    }, true);

    window.addEventListener('resize', refreshThumbArrows);
    window.addEventListener('load', function () {
      refreshThumbArrows();
      setTimeout(refreshThumbArrows, 400);
    });

    /* theme editor */
    document.addEventListener('shopify:section:load', function () {
      window.__pjGalleryInit();
    });
  }

  /* ---------------------------------------------------------- init */
  function init() {
    if (!readData()) return;
    state.ready = true;

    bindGlobal();
    bindSwipe();
    markActive(state.ids[state.index]);
    updateMainArrows();
    refreshThumbArrows();
    setTimeout(refreshThumbArrows, 300);
  }

  window.__pjGalleryInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();